export const rotation = {
    rotate90: 6,
    rotate270: 8,
    rotate180: 3
}
